/**
 * LandingEbg — "Powered by the EBG Group".
 * Centered header above two counter-scrolling horizontal logo
 * marquees (pause on hover).
 */
import { ArrowRight, Layers } from 'lucide-react';

const BRANDS = [
    '/images/brands/1.png',
    '/images/brands/2.png',
    '/images/brands/3.png',
    '/images/brands/4.png',
    '/images/brands/5.png',
    '/images/brands/6.png',
    '/images/brands/7.png',
    '/images/brands/8.png',
    '/images/brands/9.png',
    '/images/brands/10.png',
    '/images/brands/11.png',
    '/images/brands/12.png',
    '/images/brands/13.png',
    '/images/brands/14.png',
    '/images/brands/15.png',
    '/images/brands/16.png',
    '/images/brands/17.png',
    '/images/brands/18.png',
    '/images/brands/19.png',
    '/images/brands/20.png',
    '/images/brands/22.png',
    '/images/brands/23.png',
    '/images/brands/24.png',
    '/images/brands/25.png',
    '/images/brands/26.png',
    '/images/brands/27.png',
    '/images/brands/28.png',
    '/images/brands/29.png',
    '/images/brands/30.png',
    '/images/brands/31.png',
    '/images/brands/32.png',
    '/images/brands/33.png',
    '/images/brands/34.png',
    '/images/brands/35.png',
];

function brandLabel(src) {
    const m = String(src).match(/(\d+)\.png$/);
    return m ? `EBG brand ${m[1]}` : 'EBG brand';
}

const ROW_A = BRANDS.filter((_, i) => i % 2 === 0);
const ROW_B = BRANDS.filter((_, i) => i % 2 === 1);

function MarqueeRow({ logos, direction }) {
    const loop = [...logos, ...logos];
    return (
        <div className="lp-marquee-row relative overflow-hidden">
            <div aria-hidden className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 sm:w-36 bg-gradient-to-r from-white to-transparent" />
            <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 sm:w-36 bg-gradient-to-l from-white to-transparent" />
            <div className={`lp-marquee gap-4 sm:gap-5 py-2 ${direction === 'right' ? 'lp-marquee--right' : 'lp-marquee--left'}`}>
                {loop.map((src, i) => (
                    <div
                        key={`${src}-${i}`}
                        className="flex h-24 w-40 sm:h-28 sm:w-48 shrink-0 items-center justify-center rounded-2xl bg-white px-6 ring-1 ring-ink-100 shadow-card transition hover:ring-brand-teal/30"
                    >
                        <img
                            src={src}
                            alt={brandLabel(src)}
                            className="max-h-[70%] max-w-full object-contain transition duration-500 hover:scale-[1.04]"
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function LandingEbg() {
    return (
        <section id="network" className="relative scroll-mt-24 bg-white">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-20 lg:pt-28">
                <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-14" data-aos="fade-up">
                    <span className="lp-chip mb-6">
                        The network
                    </span>
                    <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-ink-900">
                        Powered by the{' '}
                        <span className="bg-gradient-to-r from-brand-teal to-brand-teal-700 bg-clip-text text-transparent">
                            EBG Group.
                        </span>
                    </h2>
                    <p className="mt-5 text-ink-600 leading-relaxed text-lg">
                        AGEON is part of EBG Group&rsquo;s portfolio of 50+ brands across technology, lifestyle and
                        food. Built with the same engineering rigour as Daewoo &amp; Carlton Wellness — applied to
                        India&rsquo;s longevity story.
                    </p>
                    <a
                        href="https://theebg.com"
                        target="_blank"
                        rel="noreferrer"
                        className="ag-btn-outline mt-8 inline-flex rounded-full px-6 py-3"
                    >
                        Visit theebg.com <ArrowRight className="h-4 w-4" />
                    </a>
                </div>
            </div>

            <div className="space-y-4 sm:space-y-5 pb-20 lg:pb-28" data-aos="fade-up" data-aos-delay="120">
                <MarqueeRow logos={ROW_A} direction="left" />
                <MarqueeRow logos={ROW_B} direction="right" />
            </div>
        </section>
    );
}
